import TextareaInput from "./textarea.js"

export default TextareaInput
